import React from "react";
import UpgradeCard from "./upgrade-card";
import Icon from "../../components/icon";
import enterprise from "../../assets/icons/enterprise";
import Flex from "../../components/flex";
import Link from "../../components/link";

const PriceIcon = () => <Icon svg={enterprise} width="40px" height="47px" />;

const Action = () => (
    <Flex style={{ minHeight: "36px" }} justifyContent="center">
        <Link to="/upgrade/inquiry">Contact us for a tailored offer</Link>
    </Flex>
);

const UpgradeCardEnterprise = () => (
    <UpgradeCard
        listItems={[
            "Dedicated success manager",
            "White glove onboarding",
            "Advanced security and controls",
        ]}
        listStartItem="Everything in Team plus:"
        pricingItems={[PriceIcon]}
        title="enterprise"
        subtitle="For teams of 10+"
        Action={Action}
    />
);

export default UpgradeCardEnterprise;
